import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@material-ui/core';
import { createDefaultTitle, Title } from '../../domain/domain';
import React, { useState } from 'react';

type Props = {
    open: boolean,
    onOK: (title: Title) => void,
    onCancel: () => void
}

const AddTitleDialog : React.FC<Props> = ({open, onOK, onCancel}) => {

    const [title, setTitle] = useState<Title>(createDefaultTitle());

    return (
        <Dialog
            open={open}
            title="Add New Title"
            onClose={() => onCancel()}
            maxWidth='sm'
            fullWidth={true}
        >
            <DialogTitle>Add New Title</DialogTitle>
            <DialogContent>
            <Grid item style={{width: '100%'}}>
                        <Grid container direction='column' spacing={0}>
                            <Grid item>
                                <Typography style={{width: '100%'}}>Title Number</Typography>     
                            </Grid>
                            <Grid item style={{width: '100%'}}>
                                <TextField
                                    variant='outlined'
                                    value={title.titleNumber}
                                    onChange={(event) => {
                                        setTitle({...title, titleNumber: (event.target.value) + ""})
                                    }}
                                    size='small'
                                    fullWidth={true}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                <br></br>
                <Grid container direction='column' spacing={2} alignItems='flex-start'>
                    <Grid item style={{width: '100%'}}>
                        <Grid container direction='column' spacing={0}>
                            <Grid item>
                                <Typography style={{width: '100%'}}>Title Name</Typography>     
                            </Grid>
                            <Grid item style={{width: '100%'}}>
                                <TextField
                                    variant='outlined'
                                    value={title.titleName}
                                    onChange={(event) => {
                                        setTitle({...title, titleName: event.target.value})
                                    }}
                                    size='small'
                                    fullWidth={true}
                                />
                            </Grid>
                        </Grid>
                    </Grid>  
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button size='small' variant='text' color='secondary' onClick={() => onCancel()}>Cancel</Button>
                <Button size='small' variant='contained' color='primary' onClick={() => onOK(title)}>Add Title</Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddTitleDialog;